<template>
  <el-collapse-item
      class="order"
  >
    <template #title="{ isActive }">
      <div :class="['order__top', { 'is-active': isActive }]">
        <div>
          <p>{{ t('profile.purchases.id') }}: {{ order.humanReadableId }}</p>
          <p v-if="order.buyTime">{{ dayjs(order.buyTime).format('MMM D YYYY HH:mm') }}</p>
          <el-tooltip
              :content="order.status"
              placement="top"
          >
            <p class="status">
              {{ order.status }}
              <img src="@icons/statusIcon.svg" alt="status">
            </p>
          </el-tooltip>
        </div>
        <img
            src="@icons/arrow.svg"
            alt="arrow"
            class="order__top-icon"
            :class="[{ active: isActive }]"
        >
      </div>
      <div class="order__top-bottom" :class="{ active: !isActive }">
        <div>
          <div>
            <div>
              <img
                  v-for="product in order.orderProducts.edges"
                  :key="product.node.uuid"
                  :src="product.node.product.images.edges[0].node.image"
                  :alt="product.node.product.name"
              />
            </div>
            <p>{{ order.totalPrice }}<span style="color: #3b3b3b">€</span></p>
          </div>
        </div>
      </div>
    </template>
    <div class="order__main">
      <div
          class="order__product"
          v-for="product in order.orderProducts.edges"
          :key="product.node.uuid"
      >
        <div class="order__product-left">
          <img
              :src="product.node.product.images.edges[0].node.image"
              :alt="product.node.product.name"
          />
          <div>
            <p>{{ product.node.product.name }}</p>
            <span>{{ product.node.attributes.code }}</span>
          </div>
        </div>
        <div class="order__product-right">
          <h6>{{ t('profile.purchases.price') }}: {{ product.node.product.price * product.node.quantity }}<span style="color: #3b3b3b">€</span></h6>
          <p>{{ product.node.quantity }} X {{ product.node.product.price }}<span style="color: #3b3b3b">€</span></p>
        </div>
      </div>
      <div class="order__total">
        <p>{{ t('profile.purchases.total') }}: {{ order.totalPrice }}<span style="color: #3b3b3b">€</span></p>
      </div>
    </div>
  </el-collapse-item>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import dayjs from "dayjs";

const props = defineProps({
  order: Object
})

const {t, locale} = useI18n();

// const statusColor = (status) => {
//   switch (status) {
//     case orderStatuses.FAILED:
//       return '#FF0000';
//
//     case orderStatuses.PAYMENT:
//       return '#FFC107';
//
//     case orderStatuses.CREATED:
//       return '#007BFF';
//
//     case orderStatuses.DELIVERING:
//       return '#00C853';
//
//     case orderStatuses.FINISHED:
//       return '#00C853';
//
//     case orderStatuses.MOMENTAL:
//       return '#00C853';
//
//     default:
//       return '#000';
//   }
// };
</script>

<style scoped lang="scss">
.order {
  &__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    padding: 0 10px 5px 10px;

    & div {
      display: flex;
      align-items: center;
      gap: 25px;

      & p {
        display: flex;
        align-items: center;
        gap: 5px;

        font-size: 14px;
        font-weight: 600;
        color: #222;

        &.status {
          background-color: #eeeeee;
          border-radius: 10px;
          padding: 3px 7px;
        }
      }
    }

    &-icon {
      transition: 0.2s;

      &.active {
        transform: rotate(-180deg);
      }
    }

    &-bottom {
      display: grid;
      grid-template-rows: 0fr;
      transition: grid-template-rows 0.2s ease;
      overflow: hidden;

      &.active {
        grid-template-rows: 1fr;
      }

      & > * {
        min-height: 0;
      }

      & div {
        & div {
          padding-top: 10px;
          border-top: 1px solid #008ECC;
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          gap: 25px;

          & div {
            padding-top: 0;
            border: none;
            display: flex;
            flex-wrap: wrap;
            gap: 10px;

            & img {
              height: 75px;
              border-radius: 10px;
            }
          }

          & p {
            display: flex;
            align-items: center;
            gap: 5px;

            font-weight: 600;
            font-size: 20px;
          }
        }
      }
    }
  }

  &__main {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  &__product {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding-bottom: 15px;
    border-bottom: 2px solid #008ECC;

    &-left {
      display: flex;
      align-items: flex-start;
      gap: 10px;

      & img {
        height: 150px;
        border-radius: 10px;
      }

      & p {
        font-size: 18px;
        font-weight: 500;
      }
    }

    &-right {
      display: flex;
      flex-direction: column;
      align-items: flex-end;

      & h6 {
        display: flex;
        align-items: center;
        gap: 5px;

        font-size: 20px;
      }

      & p {
        display: flex;
        align-items: center;
        gap: 5px;

        font-size: 14px;
      }
    }
  }

  &__total {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;

    & p {
      display: flex;
      align-items: center;
      gap: 5px;

      font-size: 20px;
      font-weight: 600;
    }
  }
}

:deep(.el-collapse-item__header) {
  height: fit-content;
  padding-block: 10px;
}
</style>